import axios from "axios"
import library from "../../../utils/Library"

export const getCommSubscriptionDetails = async (cuit) => {
  const TOKEN = sessionStorage.getItem("token")
  const URL =
    library.getBaseAPIUrl("legal_communications") +
   `/getCommSubscriptionDetailsCommunicationVE?cuitCliente=${cuit}`

  return await axios({
    url: URL,
    method: "GET",
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  })
}
